export default function Features() {
  const features = [
    {
      icon: 'ri-star-line',
      title: 'Premium Quality Henna Powder',
      description: 'Sourced from the finest Sojat henna leaves'
    },
    {
      icon: 'ri-filter-3-line',
      title: 'Finely Filtered (Fine Mesh)',
      description: 'Ultra-smooth texture for easy application'
    },
    {
      icon: 'ri-seedling-line',
      title: 'Fresh Crop Sojat Henna',
      description: 'Harvested from the latest crop season'
    },
    {
      icon: 'ri-drop-line',
      title: 'Smooth Texture for Easy Mixing',
      description: 'Blends perfectly with water or other ingredients'
    },
    {
      icon: 'ri-scissors-cut-line',
      title: 'Suitable for Hair & Mehndi',
      description: 'Versatile application for multiple uses'
    },
    {
      icon: 'ri-palette-line',
      title: 'No Artificial Colors',
      description: '100% natural green color from pure henna'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Easy to Apply and Rinse',
      description: 'User-friendly application and removal'
    },
    {
      icon: 'ri-leaf-line',
      title: '100% Pure Henna Leaves Powder',
      description: 'No additives, chemicals, or preservatives'
    }
  ];

  return (
    <section id="features" className="py-20 bg-gradient-to-b from-green-50 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Product Features
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-6"></div>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            What makes our henna powder stand out from the rest
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all transform hover:-translate-y-2"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-green-500 to-green-600 rounded-lg flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}